/**
 * Constants for Contractor Management
 * Countries, Provinces/States, and Disciplines
 */

// Countries available for contractor selection
export const COUNTRIES = ['Canada', 'U.S.'];

// Canadian Provinces and Territories (alphabetical)
export const PROVINCES_CANADA = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon'
];

// U.S. States (alphabetical)
export const STATES_US = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming'
];

// Disciplines for contractor categorization
// Start with Civil, more will be added as needed
export const DISCIPLINES = [
  'Civil'
];

/**
 * Get provinces/states based on selected country
 * @param {string} country - 'Canada' or 'U.S.'
 * @returns {string[]} Array of provinces or states
 */
export const getProvincesForCountry = (country) => {
  if (country === 'Canada') return PROVINCES_CANADA;
  if (country === 'U.S.') return STATES_US;
  return [];
};

/**
 * Get the label for province/state based on country
 * @param {string} country - 'Canada' or 'U.S.'
 * @returns {string} Label text
 */
export const getProvinceLabel = (country) => {
  if (country === 'Canada') return 'Province/Territory';
  if (country === 'U.S.') return 'State';
  return 'Province/State';
};
